import { Control } from "react-hook-form";

import { ClientDto } from "#modules/clients/infra/Client.dto";
import { MaterialGradeDetail } from "#modules/materials/view/useMaterialGradeDetails";
import { ValueType } from "#modules/similarPart/view/filters/FilterPropertyInputController";
import { NativeSelectInputController } from "#shared/view/designSystem/inputs/NativeSelectInputController";
import { NumberInputController } from "#shared/view/designSystem/inputs/NumberInputController";
import { TextInputController } from "#shared/view/designSystem/inputs/TextInputController";
import { FilterQuery } from "shared";

type Props = {
  propertyValueType: ValueType | undefined;
  expressionIndex: number;
  control: Control<FilterQuery>;
  materialGradeDetails: MaterialGradeDetail[];
  toleranceList: string[];
  clients: ClientDto[];
};

export const FilterValueInputController = ({
  propertyValueType,
  expressionIndex,
  control,
  materialGradeDetails,
  toleranceList,
  clients,
}: Props) => {
  switch (propertyValueType) {
    case "size":
      return (
        <NumberInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          unit="mm"
          control={control}
        />
      );

    case "number":
      return (
        <NumberInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
        />
      );
    case "materialGrade":
      return (
        <NativeSelectInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
          data={materialGradeDetails.map((grade) => ({
            value: grade.materialGrade,
            label: `${grade.name}${
              grade.materialGrade === "OTHER" ? " - préciser en commentaire" : ""
            }`,
          }))}
        />
      );
    case "tolerance":
      return (
        <NativeSelectInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
          data={toleranceList.map((tolerance) => ({
            value: tolerance,
            label: tolerance,
          }))}
        />
      );
    case "client":
      return (
        <NativeSelectInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
          data={clients.map((client) => ({
            value: client.id,
            label: client.name,
          }))}
        />
      );
    case "feature":
      return (
        <NativeSelectInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
          data={[
            { label: "des plis", value: "Folding" },
            { label: "des trous", value: "Hole" },
          ]}
        />
      );

    case "text":
      return (
        <TextInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
        />
      );

    case "percentage":
      return (
        <NumberInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
          unit="%"
        />
      );
    default:
      return (
        <TextInputController
          key={propertyValueType}
          name={`filterGroup.expressions.${expressionIndex}.value`}
          control={control}
        />
      );
  }
};
